import {
  ACCEPTED_PROJECT_PROCESS,
  ACCEPTED_PROJECT_PROCESS_FAIL,
  ACCEPTED_PROJECT_PROCESS_SUCCESS,
  DEL_PROJECT_PROCESS,
  DEL_PROJECT_PROCESS_FAIL,
  DEL_PROJECT_PROCESS_SUCCESS,
  DESELECT_GP,
  GET_GPP_BYGPID,
  GET_GPP_BYGPID_FAIL,
  GET_GPP_BYGPID_SUCCESS,
  GET_LIST_PROJECT_PROCESS_ENG,
  GET_LIST_PROJECT_PROCESS_ENG_FAIL,
  GET_LIST_PROJECT_PROCESS_ENG_SUCCESS,
  GET_PROJECT_PROCESS_ENG,
  GET_PROJECT_PROCESS_ENG_FAIL,
  GET_PROJECT_PROCESS_ENG_SUCCESS,
  PROJECT_PROCESS,
  PROJECT_PROCESS_FAIL,
  PROJECT_PROCESS_SUCCESS,
  RESET_GAS_PROCESS_FLAG,
  SELECT_GP,
} from "./actionTypes"

const INIT_STATE = {
  lstGpp: [],
  lstProjectProcessEng: [],
  lstProjectProcessEngTotal: 0,
  projectProcessEng: [],
  projectProcessEngTotal: 0,
  selectedProject: [{ page: 1, selectArr: [] }],
  flatSelectedProject: { projectId: [] },
  countSelectedProject: 0,
  error: "",
  success: "",
  loading: false,
  triggerReload: 0,
}

const gasProjectProcesses = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_GPP_BYGPID:
    case PROJECT_PROCESS:
    case GET_LIST_PROJECT_PROCESS_ENG:
    case DEL_PROJECT_PROCESS:
    case GET_PROJECT_PROCESS_ENG:
    case ACCEPTED_PROJECT_PROCESS:
      return {
        ...state,
        loading: true,
      }
    case GET_GPP_BYGPID_SUCCESS:
      return {
        ...state,
        loading: false,
        lstGpp: action.payload,
      }
    case PROJECT_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "با موفقیت تخصیص انجام شد",
        triggerReload: state.triggerReload + 1,
      }

    case DEL_PROJECT_PROCESS_SUCCESS:
      return {
        ...state,
        loading: false,
        success: "با موفقیت حذف شد",
        triggerReload: state.triggerReload + 1,
      }
      case ACCEPTED_PROJECT_PROCESS_SUCCESS:
        return {
          ...state,
          loading: false,
          success: "با موفقیت انجام شد",
          triggerReload: state.triggerReload + 1
        }

    case GET_LIST_PROJECT_PROCESS_ENG_SUCCESS:
      return {
        ...state,
        loading: false,
        lstProjectProcessEng: action.payload.data,
        lstProjectProcessEngTotal: action.payload.totalItems,
      }

    case GET_PROJECT_PROCESS_ENG_SUCCESS:
      return {
        ...state,
        loading: false,
        projectProcessEng: action.payload.data,
        projectProcessEngTotal: action.payload.totalItems,
      }

    case GET_GPP_BYGPID_FAIL:
    case PROJECT_PROCESS_FAIL:
    case GET_LIST_PROJECT_PROCESS_ENG_FAIL:
    case DEL_PROJECT_PROCESS_FAIL:
    case GET_PROJECT_PROCESS_ENG_FAIL:
    case ACCEPTED_PROJECT_PROCESS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload ? action.payload : "خطای پیش بینی نشده",
        success: "",
      }

    case SELECT_GP:
      if (
        state.selectedProject.findIndex(x => x.page === action.payload.page) ===
        -1
      )
        state.selectedProject.push(action.payload)
      let newSelectedProject = state.selectedProject.map(x => {
        if (x.page === action.payload.page)
          return { ...x, selectArr: action.payload.selectArr }
        return x
      })
      let countSelected = 0
      let flatSelected = { projectId: [] }
      newSelectedProject.forEach(element => {
        countSelected += element.selectArr.length
        element.selectArr.forEach(arr => flatSelected.projectId.push(arr))
      })
      return {
        ...state,
        selectedProject: newSelectedProject,
        countSelectedProject: countSelected,
        flatSelectedProject: flatSelected,
      }

    case DESELECT_GP:
      return {
        ...state,
        countSelectedProject: 0,
        selectedProject: [{ page: 1, selectArr: [] }],
        flatSelectedProject: { projectId: [] },
      }

    case RESET_GAS_PROCESS_FLAG:
      return {
        ...state,
        success: null,
        error: null,
        triggerReload: 0,
      }

    default:
      return state
  }
}

export default gasProjectProcesses
